import React, { createContext, useState, useContext } from 'react';

// Create the context
const GlobalContext = createContext();

// Create a custom hook to access the context easily
export const useGlobal = () => useContext(GlobalContext);

// Create a provider component
export const GlobalProvider = ({ children }) => {
    const [categoryKeyword, setCategoryKeyword] = useState('');
    const [keyword, setKeyword] = useState('');
    const [keywordCreator, setKeywordCreator] = useState('');
    const [age, setAge] = useState('');
    const [sort, setSort] = useState('newest');
    const [min, setMin] = useState('');
    const [max, setMax] = useState('');
    const [priceRange, setPriceRange] = useState('')
    const [pageNumber, setPageNumber] = useState(1);
    const [hasBecome, setHasBecome] = useState(false);

    const updateKeyword = (newKeyword) => setKeyword(newKeyword);
    const updateKeywordCreator = (newKeywordCreator) => setKeywordCreator(newKeywordCreator);
    const updateAge = (newAge) => setAge(newAge);
    const updateSort = (newSort) => setSort(newSort);
    const updateMin = (newMin) => setMin(newMin);
    const updateMax = (newMax) => setMax(newMax);
    const updatePriceRange = (newPriceRange) => setPriceRange(newPriceRange);
    
    const updatePageNumber = (newPageNumber) => setPageNumber(newPageNumber);
    const updateHasBecome = (newHasBecome) => setHasBecome(newHasBecome);
    const updateCategoryKeyword = (newCategoryKeyword) => setCategoryKeyword(newCategoryKeyword);
    

    return (
        <GlobalContext.Provider
            value={{
                
                keyword,
                keywordCreator,
                age,
                sort,
                min,
                max,
                pageNumber,
                hasBecome,
                categoryKeyword,
                priceRange,
                setCategoryKeyword: updateCategoryKeyword,
                setKeyword: updateKeyword,
                setKeywordCreator: updateKeywordCreator,
                setAge: updateAge,
                setSort: updateSort,
                setMin: updateMin,
                setMax: updateMax,
                setPriceRange: updatePriceRange,
                setPageNumber: updatePageNumber,
                setHasBecome: updateHasBecome,
                
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};
